import { render, staticRenderFns } from "./StudyBulkAnswerVertical.vue?vue&type=template&id=bf16d0b6&scoped=true&lang=pug"
import script from "./StudyBulkAnswerVertical.vue?vue&type=script&lang=ts"
export * from "./StudyBulkAnswerVertical.vue?vue&type=script&lang=ts"
import style0 from "./StudyBulkAnswerVertical.vue?vue&type=style&index=0&id=bf16d0b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf16d0b6",
  null
  
)

export default component.exports